import { IApiRequest, IApiResponse, fetchApi } from '../../core/auth/fetchApiHelper';
import { logger } from '../../core/diagnostics/logger';
import { processConfig } from '../../environment.constants';
import { IProductSearchResultsModel, IUserCartActivityMdoel } from './v2/anlytics.interfaces';

export const insertProductSearchResults = async (
  productSearchResultsModel: IProductSearchResultsModel
): Promise<IApiResponse<number>> => {
  try {
    const request: IApiRequest = {
      url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Analytics/insert-product-search-results-model`,
      method: 'POST',
      contentType: 'application/json',
      requireAccessToken: true,
      body: productSearchResultsModel
    };

    const response = await fetchApi<number>(request);
    return response;
  } catch (e) {
    logger.error('error inserting product search results record', e as Error);
    throw e;
  }
};

export const MergeUserCartActivity = async (
  userCartActivityModels: IUserCartActivityMdoel[]
): Promise<IApiResponse<IUserCartActivityMdoel>> => {
  try {
    const request: IApiRequest = {
      url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Analytics/merge-user-cart-activity`,
      method: 'POST',
      contentType: 'application/json',
      requireAccessToken: true,
      body: userCartActivityModels
    };

    const response = await fetchApi<IUserCartActivityMdoel>(request);
    return response;
  } catch (e) {
    logger.error('error merging user cart activity', e as Error);
    throw e;
  }
};

export interface ILogAnalyticsEventModel {
  readonly sessionId: number;
  readonly eventTypeId: number;
  readonly customerAzureUserId: string | null;
  readonly internalCompanyAzureUserId: string | null;
  readonly eventDate: string;
}

export const createEvent = async (model: ILogAnalyticsEventModel): Promise<void> => {
  const request: IApiRequest = {
    url: `${processConfig.baseGatewayUrl}/shopping-svc/v1.0/Analytics/create-event`,
    method: 'POST',
    contentType: 'application/json',
    requireAccessToken: true,
    body: model
  };

  await fetchApi(request);
};
